import { PropsWithChildren } from 'react'

import { GenericalRecord } from '@eastcoal/common/types/utilities'

import { CrudFormCore } from './FormCore'
import { CrudFormReadError } from './FormError/ReadError'
import { CrudFormSubmitError } from './FormError/SubmitError'
import { CrudFormFooter } from './FormFooter'
import { CrudFormProps } from './interface'
import { CrudFormStoreProvider } from './Store'

export const CrudForm = <
  FormData extends GenericalRecord,
  DetailData extends GenericalRecord,
  Context
>({
  className,
  style,
  styles,
  bodyClassName,
  footerClassName,
  header,
  children,

  /* -------------------------------------------------------------------------- */
  /*                         CrudFormStoreProvider Props                        */
  /* -------------------------------------------------------------------------- */
  mode,
  detailType,
  mergeStrategy,
  initialValues,
  values,
  validateFirst,
  form,
  context,
  effects,
  readApi,
  createApi,
  updateApi,
  onSuccess,
  onModeChange,

  /* -------------------------------------------------------------------------- */
  /*                             CrudFormCore Props                             */
  /* -------------------------------------------------------------------------- */
  name,
  schema,
  grid,
  layout,

  /* -------------------------------------------------------------------------- */
  /*                            CrudFormFooter Props                            */
  /* -------------------------------------------------------------------------- */
  footer,
  actions,
  moreActions
}: PropsWithChildren<CrudFormProps<FormData, DetailData, Context>>) => {
  return (
    <CrudFormStoreProvider
      context={context}
      createApi={createApi}
      detailType={detailType}
      effects={effects}
      form={form}
      initialValues={initialValues}
      mergeStrategy={mergeStrategy}
      mode={mode}
      readApi={readApi}
      updateApi={updateApi}
      validateFirst={validateFirst}
      values={values}
      onModeChange={onModeChange}
      onSuccess={onSuccess}
    >
      <div className={className} style={style}>
        {header}
        <CrudFormReadError />
        <CrudFormCore
          className={bodyClassName}
          grid={grid}
          layout={layout}
          name={name}
          schema={schema}
          style={styles?.body}
        >
          <CrudFormSubmitError />
        </CrudFormCore>
        {footer !== undefined ? (
          footer
        ) : (
          <CrudFormFooter
            actions={actions}
            className={footerClassName}
            moreActions={moreActions}
            style={styles?.footer}
          />
        )}
        {children}
      </div>
    </CrudFormStoreProvider>
  )
}
